module.exports = __webpack_public_path__ + "media/new_ui/google-play-badge-dec44f5f.png";